const $ = jQuery;

class LayoutLoader {
    
    constructor(layouts){
        
        // save our component definitions
        this.layouts = layouts;

        if (window.MutationObserver) {
            const observer = new MutationObserver(() => this.parse());
            observer.observe(document.documentElement, {
                childList: true,
                subtree: true
            });
        }
        $(()=>this.parse());
    }

    parse(){
        const $layouts = $('[data-js-layout]');
        
        $layouts.each( async (i, el) => {

            const name = $(el).data('js-layout');
            $(el).attr('data-js-layout', null);

            if (!this.layouts[name]) {
                return;
            }
            const config = $(el).data('layout-config');
            const layout = await this.layouts[name];

            $(el).data('js-layout', layout.default.render( el, config));
            $(el).attr('data-js-layout-rendered', '1');
        });
    }
}

export default LayoutLoader;